import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { AxiosError } from 'axios';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { PostRecentProjectParams } from '../constants/types';

type PostRecentProjectOptions = UseMutationOptions<string[], AxiosError, PostRecentProjectParams>;

/**
 * 현재 사용자가 최근 사용 프로젝트를 업데이트하는 훅입니다.
 * @description
 * - react-query로 mutate를 제공합니다.
 */
const usePostRecentProject = (options?: PostRecentProjectOptions) => {
  const client = useQueryClient();
  const { postRecentProject } = useMetaApiInstance();

  const mutation = async (param: PostRecentProjectParams) => {
    const response = await postRecentProject(param);
    return response;
  };

  return useMutation({
    mutationKey: [HOST_QUERY_KEY.UPDATE_RECENT_PROJECT],
    mutationFn: mutation,
    onSuccess: res => {
      client.setQueryData<string[]>([HOST_QUERY_KEY.GET_RECENT_PROJECT], res);
    },
    ...options,
  });
};

export default usePostRecentProject;
